import React from 'react';

export default function ZoomOut(props) {
  return (
    <svg preserveAspectRatio="xMidYMid" viewBox="0 0 47.906 48" {...props}>
      <path d="M47.610,47.707 C47.415,47.902 47.160,48.000 46.904,48.000 C46.649,48.000 46.394,47.902 46.199,47.707 L29.921,31.395 C26.740,34.248 22.556,36.000 17.961,36.000 C8.055,36.000 -0.004,27.925 -0.004,18.000 C-0.004,8.075 8.055,0.000 17.961,0.000 C27.868,0.000 35.928,8.075 35.928,18.000 C35.928,22.603 34.179,26.795 31.332,29.981 L47.610,46.293 C48.000,46.684 48.000,47.317 47.610,47.707 ZM33.932,18.000 C33.932,9.178 26.767,2.000 17.961,2.000 C9.156,2.000 1.992,9.178 1.992,18.000 C1.992,26.822 9.156,34.000 17.961,34.000 C26.767,34.000 33.932,26.822 33.932,18.000 ZM25.945,19.000 L9.976,19.000 C9.425,19.000 8.978,18.552 8.978,18.000 C8.978,17.448 9.425,17.000 9.976,17.000 L25.945,17.000 C26.497,17.000 26.943,17.448 26.943,18.000 C26.943,18.552 26.497,19.000 25.945,19.000 Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/zoom-out.js